export default __webpack_public_path__ + "static/media/ALICE-BNB.5bcf2d33.svg";